// angular
import { Component, inject, input } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// components
import { FiltersBoxComponent } from '@app/core/components/filters-box/filters-box.component';

@Component({
  selector: 'pwj-suppliers-filters',
  standalone: true,
  imports: [FiltersBoxComponent, TranslateModule],
  templateUrl: './suppliers-filters.component.html',
  styleUrl: './suppliers-filters.component.scss',
})
export class SuppliersFiltersComponent {
  // inputs
  pageTitle = input<string>('');

  // dependencies
  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _router = inject(Router);

  public applyFilter(filterValue: string[], filterQueryName?: string) {
    let queryParams: Params;

    // implement params
    queryParams = {
      take: null,
      skip: null,
      [filterQueryName as string]: filterValue?.length > 0 ? filterValue : null,
    };

    // set params in route
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
